'use strict';
import * as $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError from "./com.raquo.airstream.core.-Airstream-Error.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
class $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded extends $j_com$002eraquo$002eairstream$002ecore$002e$002dAirstream$002dError.$c_Lcom_raquo_airstream_core_AirstreamError {
  constructor(trx, depth) {
    super();
    this.lt = null;
    this.ls = 0;
    this.lt = trx;
    this.ls = depth;
    $j_java$002elang$002e$002dObject.$ct_jl_Throwable__T__jl_Throwable__Z__Z__(this, (((("Transaction depth exceeded maxDepth = " + depth) + ": Execution of ") + trx) + " aborted. See `Transaction.maxDepth`."), null, true, true);
  }
  I() {
    return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
  }
  m() {
    var acc = (-889275714);
    acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$f_T__hashCode__I("TransactionDepthExceeded"));
    acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.lt));
    acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.ls);
    return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 2);
  }
  f(x$0) {
    if ((this === x$0)) {
      return true;
    } else if ((x$0 instanceof $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded)) {
      if ((this.ls === x$0.ls)) {
        var x = this.lt;
        var x$2 = x$0.lt;
        return ((x === null) ? (x$2 === null) : (x === x$2));
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  n() {
    return 2;
  }
  o() {
    return "TransactionDepthExceeded";
  }
  g(n) {
    if ((n === 0)) {
      return this.lt;
    }
    if ((n === 1)) {
      return this.ls;
    }
    throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
  }
  b() {
    return ((("TransactionDepthExceeded: " + this.lt) + "; maxDepth: ") + this.ls);
  }
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded as $c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded };
function $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cP)));
}
export { $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded as $isArrayOf_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded };
var $d_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded, "com.raquo.airstream.core.AirstreamError$TransactionDepthExceeded", ({
  cP: 1,
  bl: 1,
  H: 1,
  a: 1,
  b: 1,
  c: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded as $d_Lcom_raquo_airstream_core_AirstreamError$TransactionDepthExceeded };
